<template>
  <div>
    <el-row style="margin-bottom: 15px">
      <el-col align="right">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      </el-col>
    </el-row>
    <el-table v-loading="loading" :data="dataList" :height="height">
      <el-table-column label="商机名称" min-width="130" align="left" prop="businessName">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toDetail(scope.row)">{{scope.row.businessName}}</el-link>
        </template>
      </el-table-column>
      <el-table-column v-if="contactId" label="联系人角色" min-width="100" align="center" prop="contactRole" />
      <el-table-column label="商机级别" min-width="100" align="center" prop="businessLevelDesc" />
      <el-table-column label="商机状态" min-width="100" align="center" prop="businessStatusDesc" />
      <el-table-column label="商机阶段" min-width="100" align="center" prop="currentStageDesc" />
      <el-table-column label="负责人" min-width="100" align="center" prop="userName" />
      <el-table-column label="预计成交金额(元)" min-width="130" align="center" prop="estimateDealAmount">
        <template slot-scope="scope">
          <span>{{ Number(scope.row.estimateDealAmount) / 10000 }}万</span>
        </template>
      </el-table-column>
      <el-table-column label="预计成交时间" min-width="110" align="center" prop="estimateDealDate" />
      <el-table-column label="签约金额(元)" min-width="130" align="center" prop="signAmount">
        <template slot-scope="scope">
          <span>{{ Number(scope.row.signAmount || 0) / 10000 }}万</span>
        </template>
      </el-table-column>
    </el-table>
    <AddBusinessDialog ref="addBusinessDialogRef" @success="queryList"></AddBusinessDialog>
  </div>
</template>

<script>

import {queryBusinessByTargetId} from "@/api/crm/business";
import {amountFormat} from '@/utils/index'
import AddBusinessDialog from "@/views/crm/business/addBusinessDialog";

export default {
  name: "BusinessList",
  props: {
    customerId: null,
    paramData: {
      type: Object,
      default: {}
    },
    contactId: null,
    height: {
      type: String,
      default () {
        return "250"
      }
    }
  },
  data() {
    return {
      loading: false,
      dataList: [],
      amountFormat
    };
  },
  created() {
    if (this.customerId || this.contactId) {
      this.queryList();
    }
  },
  components: {
    AddBusinessDialog
  },
  watch: {
    customerId (val) {
      if (val) {
        this.queryList();
      } else {
        this.dataList = []
      }
    },
    contactId (val) {
      if (val) {
        this.queryList();
      } else {
        this.dataList = []
      }
    }
  },
  methods: {
    /** 新增按钮操作 */
    handleAdd() {
      if (this.customerId) {
        this.$refs.addBusinessDialogRef.open('customerId', this.customerId, this.paramData.customerName);
      } else if (this.contactId) {
        this.$refs.addBusinessDialogRef.open();
      }
    },
    queryList () {
      this.loading = true;
      queryBusinessByTargetId(
        {
        customerId: this.customerId,
        contactId: this.contactId
      }
      ).then(response => {
          this.dataList = response.data || [];
          this.$emit('after-query', this.dataList);
          this.loading = false;
        }
      ).catch(error => {
        this.loading = false;
      });
    },
    /** 详细按钮操作 */
    toDetail(row) {
      window.open("/crm/business/detail/" + row.id, "_blank")
    },
  }
};
</script>
